
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/prakshep",
      function () {
        return require("private-next-pages/prakshep.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/prakshep"])
      });
    }
  